<template>
	<div id="app" :class="!is_mobile ? 'mobile' : ''">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
    name: 'app',
	data() {
		return {
			is_mobile: false,
		}
	},
	created() {
		let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		if(!flag) {
			//移动端
			this.is_mobile = true;
		}
	}
}
</script>
<style>
@charset "utf-8";
::-webkit-input-placeholder{color:#999999;}
/* ::-webkit-scrollbar{display:none;width:0 !important;height:0 !important;-webkit-appearance:none;background:transparent;} */
*{margin:0;padding:0;font-family: "PFFont, Helvetica";outline:none;text-decoration:none;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0);touch-action: pan-y;}
img{vertical-align:top;}/*, "Noto Sans SC", "Helvetica"*/
html,body{width:100%;height:100%;margin:0px;padding:0px;-webkit-overflow-scrolling:touch;}ul,li{list-style:none;}
input,div,span,select,textarea,button{letter-spacing:0.5px;}
input{-webkit-appearance: none;}
a{color:#999999;}
/*loading*/
.loading{width:100%;height:100vh;position:absolute;display:flex;justify-content:center;align-items:center;top:0;right:0;bottom:0;left:0;background:#ffffff;z-index:999;}
.box_tit{
	font-size: 30px;
	font-weight: 500;
}
.container{
	/* margin-top: 50px; */
}
.container, .main{position:relative;width:100%;height:100%;min-width:1200px;overflow: hidden;font-size: 14px;/* background-color: #ebebec; */}
.main_box{width: 1200px;margin: 0 auto;}

>>> .van-sticky--fixed{width: 1200px;margin: 0 auto;}
>>> .van-tab{flex: inherit;width: 125px !important;font-size: 16px;}
>>> .van-tabs__line{background-color: #1890ff;}

.ant-popover-inner-content{
	max-width: 500px;
}

/*移动端样式*/
/* .mobile .container, .mobile .main_box, .mobile .main, .mobile .main_top, .mobile .main_bg{
	min-width: 100% !important;
} */
</style>
